import { WeaTools } from 'ecCom'

export const getHasRight = params => {
  return WeaTools.callApi('/api/hrm/birthdayinfo/hasRight', 'GET', params);
}

export const getSearchCondition = params => {
  return WeaTools.callApi('/api/hrm/birthdayinfo/getSearchCondition', 'GET', params);
}

export const getSearchList = params => {
  return WeaTools.callApi('/api/hrm/birthdayinfo/getSearchResult', 'POST', params);
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/birthdayinfo.js